import { cn } from '@lib/utils';

const MediaQueryStyle = {
  background: '2xl:flex 2xl:pt-[200px]',
  Layout: '2xl:w-[960px] 2xl:mx-auto 2xl:my-0 2xl:px-0 2xl:pb-[60px]',
  MainTitle: '2xl:text-[48px] 2xl:leading-[150%] 2xl:tracking-[-1.344px]',
  SubTitle: '2xl:text-[18px] 2xl:leading-[28px] 2xl:tracking-[-0.256px]',
}; // overide 할때 보기 편하게 상수로 선언

const Background = ({ children }: { children: React.ReactNode }) => (
  <div
    className={cn(
      'bg-3b-blue-light-900 px-5 pt-[120px] text-white',
      MediaQueryStyle.background,
    )}
  >
    {children}
  </div>
);

const Layout = ({ children }: { children: React.ReactNode }) => (
  <div className={cn('flex flex-col pb-10', MediaQueryStyle.Layout)}>
    {children}
  </div>
);

const MainTitle = ({ children }: { children: React.ReactNode }) => (
  <h1
    className={cn(
      'text-[36px] font-semibold leading-[44px] tracking-[-0.784px] text-white',
      MediaQueryStyle.MainTitle,
    )}
  >
    {children}
  </h1>
);

const SubTitle = ({ children }: { children: React.ReactNode }) => (
  <h2
    className={cn(
      'pb-6 text-[14px] font-medium leading-[22px] tracking-[-0.128px] text-[#BEC2CC]',
      MediaQueryStyle.SubTitle,
    )}
  >
    {children}
  </h2>
);

export { Background, Layout, MainTitle, SubTitle };
